import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, path = '', schema }) => {
  const baseUrl = 'https://taigasourcing.com';
  const fullUrl = `${baseUrl}${path}`;
  const defaultTitle = 'Taiga Sourcing | Multi-Category Sourcing from India';
  const defaultDescription = 'Taiga Sourcing connects global buyers with Indian manufacturers. Multi-category sourcing from India — apparel, tiles, bathware, furniture, home decor, textiles, handicrafts, packaging and more.';

  return (
    <Helmet>
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:site_name" content="Taiga Sourcing" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />

      <meta name="robots" content="index, follow" />
      <meta name="author" content="Taiga Sourcing" />

      {schema && (Array.isArray(schema) ? schema : [schema]).map((item, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
